/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../../apiResponse';
import { createApiResponseSchema } from '../../../apiResponse';

export const adminSubscriptionSchema = z.object({
  id: z.string(),
  userId: z.string(),
  planKey: z.string(),
  status: z.string(),
  platform: z.string(),
  originalTransactionId: z.string(),
  latestTransactionId: z.string().nullable(),
  purchaseDate: z.number(),
  expiresDate: z.number().nullable(),
  cancelledDate: z.number().nullable(),
  autoRenewing: z.number(),
  gracePeriodExpiresDate: z.number().nullable(),
  environment: z.string(),
  createdAt: z.number(),
  updatedAt: z.number(),
});

export type IAdminSubscription = z.infer<typeof adminSubscriptionSchema>;

export const listSubscriptionsDataSchema = z.array(adminSubscriptionSchema);

export type IListSubscriptionsData = z.infer<typeof listSubscriptionsDataSchema>;

export const listSubscriptionsResponseSchema = createApiResponseSchema(
  listSubscriptionsDataSchema,
) as z.ZodSchema<IAPI<IListSubscriptionsData>>;

export type IListSubscriptionsResponse = IAPI<IListSubscriptionsData>;
